import React from "react";
import $ from "jquery";
import {
  CurrencyRendererRed,
  CurrencyRendererPrice,
  NumberRenderer,
  GetParams,
  MWBaseURL,
  GetESTDateString,
  GetStandardDTButtons,
} from "./../Utilities.js";
import Autocomplete from "react-autocomplete";
import TagSearchTbl from "./TagSearchTbl.js";
import { createApiClient } from "../api/ApiClient";

class TagTbl extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      date: null,
      dateEnd: null,
      firm: null,
      acct: null,
      sybl: null,

      needToUpdate: false,
      skipUpdate: false,

      selectedRows: null,

      newNote: "",

      findDateRange: false,
      findDateRangeStart: props.date,
      findDateRangeEnd: props.dateEnd,
      findTag: "",
      replaceTag: "",
      completetaglist: [],
    };

    this.table = null;
    this.symbolcontroller = new AbortController();
  }

  static getDerivedStateFromProps(props, state) {
    if (
      state.date !== props.date ||
      state.dateEnd !== props.dateEnd ||
      state.firm !== props.firm ||
      state.acct !== props.acct ||
      state.sybl !== props.sybl ||
      (props.tag && state.tag !== props.tag) ||
      props.tagAndMode !== state.tagAndMode
    ) {
      return { ...props, needToUpdate: true };
    }
    return { ...props };
  }

  componentDidUpdate(props, state) {
    if (this.state.needToUpdate) {
      let self = this;
      this.setState({ needToUpdate: false }, function () {
        if (self.table !== null) {
          self.table.ajax
            .url(MWBaseURL() + "tags_v2?" + GetParams(self.state))
            .load();
          self.loadCompleteTagList();
        }
      });
    }
  }

  loadCompleteTagList() {
    let self = this;
    const apiClient = createApiClient();
    apiClient
      .get(MWBaseURL() + "users_tag_list?" + GetParams(self.state))
      .then((data) => {
        self.setState({ completetaglist: data });
      });
  }

  componentWillUnmount() {
    $(".popover").popover("dispose");
  }

  async componentDidMount() {
    let self = this;
    const apiClient = createApiClient();
    this.table = $("#tagTbl").DataTable({
      dom: "Bfrtip",
      buttons: [
        ...GetStandardDTButtons("Trac P&L Explorer Tags", true),
        {
          text: '<svg class="bi flex-shrink-0" width="16" height="16" role="img" aria-label="Search:"><use xlink:href="#search-icon"/></svg> Find and Replace',
          className: "btn btn-sm btn-secondary",
          init: function (api, node, config) {
            node.removeClass("dt-button");
            node.children(".dt-down-arrow").remove();
          },
          attr: {
            "data-toggle": "modal",
            "data-target": "#findReplaceModal",
          },
          action: function (e, dt, node, config) {
            self.loadCompleteTagList();
          },
        },
      ],
      select: {
        style: "single",
      },
      scrollY: "600px",
      scrollX: true,
      responsive: true,
      stateSave: true,
      stateDuration: 0, //infinite
      paging: false,
      info: false,
      filter: true,
      ajax: await apiClient.getDataTableAjaxSettings(
        MWBaseURL() + "tags_v2?" + GetParams(self.state),
      ),
      columns: [
        { title: "Date", data: "fdate" },
        { title: "Symbol", data: "symbol", className: "symbolInfo" },
        { title: "Start", data: "start" },
        { title: "End", data: "end" },
        {
          title: "Net P&L",
          data: "pnl",
          render: CurrencyRendererRed,
          className: "text-right",
        },
        {
          title: "Gross P&L",
          data: "gross_pnl",
          render: CurrencyRendererRed,
          className: "text-right",
        },
        {
          title: "Max Size",
          data: "max_pos",
          render: NumberRenderer,
          className: "text-right",
        },
        {
          title: "Price at Max",
          data: "max_pos_price",
          render: CurrencyRendererPrice,
          className: "text-right",
        },
        {
          title: "Avg Price at Max",
          data: "max_pos_avg_price",
          render: CurrencyRendererPrice,
          className: "text-right",
        },
        { title: "Tags", data: "tag" },
        {
          title: "Notes",
          data: "notes",
          className: "clickable editNotes",
          render: function (data, type, row, meta) {
            let value = data;

            if (data && data.length > 20) {
              value =
                `<span title="` +
                data +
                `">` +
                data.substr(0, 20) +
                `...</span>`;
            }
            return value;
          },
        },
      ],
      columnDefs: [
        {
          targets: [0, 1, 2, 3, 9, 10],
          class: "text-nowrap",
        },
      ],
    });
    this.table.on("select deselect", function (e, dt, type, indexes) {
      let rows = self.table.rows({ selected: true }).data().toArray();
      self.setState(
        { skipUpdate: true, newNote: rows.length === 1 ? rows[0].notes : "" },
        function () {
          //skip next table update
          self.state.refilter({
            selectedx0:
              rows.length === 1 ? rows[0].fdate + " " + rows[0].start : null,
            selectedx1:
              rows.length === 1 ? rows[0].fdate + " " + rows[0].end : null,
            selectedRows: rows,
          });
        },
      );
    });
    this.setState({ needToUpdate: false });

    $("#tagTbl tbody").on("click", "tr .editNotes", function () {
      $("#editTagModal").modal("show");
    });

    this.table
      .on("preDraw", function () {
        $(".popover").popover("dispose"); //doesn't seem to work on table element, so delete all
      })
      .on("draw.dt", function () {
        $("#tagTbl").popover({
          selector: "td.symbolInfo",
          customClass: "symbolPopover",
          title: () => {
            return this.querySelector(".symbolInfo:hover").innerHTML;
          },
          html: true,
          content: () => {
            return `<div class="spinner-border" role="status">
						<span class="sr-only">Loading...</span>
					</div>`;
          },
          trigger: "hover",
          delay: { show: 300 },
        });
      });
    $("#tagTbl").on("show.bs.popover", function () {
      let hoverElm = this.querySelector(".symbolInfo:hover");
      let sybl = hoverElm.innerHTML;
      self.symbolcontroller.abort();
      self.symbolcontroller = new AbortController();

      const apiClient = createApiClient();
      apiClient
        .post(
          MWBaseURL() + "symbol_info?" + GetParams(self.state),
          [
            {
              symbol: sybl.length > 15 ? sybl.slice(0, sybl.length - 15) : sybl,
              date: GetESTDateString(),
            },
          ],
          { signal: self.symbolcontroller.signal },
        )
        .then((data) => {
          let content = "N/A";
          if (data.length !== 0) {
            content = `<div>
					<div class="row"><div class="col text-nowrap"><b>Industry</b></div></div>
					<div class="row"><div class="col">${data[0].Industry}</div></div>
					<div class="row"><div class="col text-nowrap"><b>Subindustry</b></div></div>
					<div class="row"><div class="col">${data[0].Subindustry}</div></div>
					</div>`;
            $(hoverElm).data("bs.popover").config.title = data[0].Name;
          }
          $(hoverElm).data("bs.popover").config.content = content;
          $(hoverElm).data("bs.popover").setContent();
        })
        .catch((e) => console.log(e.message));
    });

    self.loadCompleteTagList();

    $("#findReplaceModal").on("hidden.bs.modal", function (event) {
      self.setState({ findTag: "", replaceTag: "" });
    });

    $("#replaceForm").on("submit", function (e) {
      e.preventDefault();
      let obj = {
        user: self.state.auth.user,
        oldTag: self.state.findTag,
        newTag: self.state.replaceTag,
      };
      if (self.state.findDateRange) {
        obj.startDate = self.state.findDateRangeStart;
        obj.endDate = self.state.findDateRangeEnd;
      }

      const apiClient = createApiClient();
      apiClient
        .post(MWBaseURL() + "tag_replace?", obj)
        .then((result) => {
          $("#findReplaceModal").modal("hide");
          self.table.ajax
            .url(MWBaseURL() + "tags_v2?" + GetParams(self.state))
            .load();
        })
        .catch((error) => {
          console.log("Error replacing tag:", error);
        });
    });
  }

  editTag = (e) => {
    let self = this;
    let data = {
      id: this.state.selectedRows[0].id,
      notes: this.state.newNote,
    };
    const apiClient = createApiClient();
    apiClient
      .post(MWBaseURL() + "tag_trade_edit?", data)
      .then((result) => {
        $("#editTagModal").modal("hide");
        self.table.ajax.reload();
      })
      .catch((error) => {
        console.log("error setting tag", error);
      });
  };

  render() {
    return (
      <div>
        <table
          id="tagTbl"
          className="display compact selectable"
          width="100%"
        ></table>
        <div
          className="modal fade"
          id="editTagModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="editNotesModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              {
                <div className="modal-header">
                  <h5 className="modal-title" id="editNotesModalLabel">
                    Edit Notes
                  </h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              }
              <div className="modal-body">
                <div className="input-group">
                  <div className="input-group-prepend">
                    <span className="input-group-text">Notes</span>
                  </div>
                  <textarea
                    id="newNote"
                    className="form-control"
                    maxLength="500"
                    autoComplete="off"
                    onChange={(e) => this.setState({ newNote: e.target.value })}
                    rows="5"
                    value={this.state.newNote}
                  ></textarea>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={this.editTag}
                >
                  Save changes
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="findReplaceModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="findReplaceModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Find and Replace</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <form id="replaceForm">
                <div className="modal-body">
                  <div className="form-group row">
                    <label
                      htmlFor="findTag"
                      className="col-sm-1 col-form-label"
                    >
                      Find
                    </label>
                    <div className="col-sm-4">
                      <Autocomplete
                        inputProps={{
                          className: "form-control",
                          maxLength: "40",
                          id: "findTag",
                          required: true,
                        }}
                        items={this.state.completetaglist}
                        getItemValue={(item) => item.tag}
                        shouldItemRender={(item, value) => {
                          return item.tag
                            .toLowerCase()
                            .includes(value.toLowerCase());
                        }}
                        renderItem={(item, highlighted) => (
                          <div
                            key={item.tag}
                            className={
                              highlighted
                                ? "dropdown-item active"
                                : "dropdown-item"
                            }
                          >
                            {item.tag}
                          </div>
                        )}
                        renderMenu={(children) => (
                          <div
                            className="autocompleteMenu"
                            style={{ zIndex: 999 }}
                          >
                            {children}
                          </div>
                        )}
                        wrapperStyle={{}}
                        value={this.state.findTag}
                        onChange={(e) => {
                          this.setState({ findTag: e.target.value });
                        }}
                        onSelect={(value) => this.setState({ findTag: value })}
                      />
                    </div>
                    <div className="col-sm-7">
                      {!this.state.findDateRange && (
                        <button
                          type="button"
                          onClick={(e) =>
                            this.setState({ findDateRange: true })
                          }
                          className="btn btn-secondary"
                        >
                          + Date Range
                        </button>
                      )}
                      {this.state.findDateRange && (
                        <div className="input-group">
                          <div className="input-group-prepend">
                            <button
                              type="button"
                              onClick={(e) =>
                                this.setState({ findDateRange: false })
                              }
                              className="btn btn-secondary"
                            >
                              − Date Range
                            </button>
                          </div>
                          <input
                            type="date"
                            className="form-control"
                            value={this.state.findDateRangeStart}
                            onChange={(e) => {
                              this.setState({
                                findDateRangeStart: e.target.value,
                              });
                            }}
                          />
                          <input
                            type="date"
                            className="form-control"
                            value={this.state.findDateRangeEnd}
                            onChange={(e) => {
                              this.setState({
                                findDateRangeEnd: e.target.value,
                              });
                            }}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="replaceTag"
                      className="col-sm-1 col-form-label"
                    >
                      Replace
                    </label>
                    <div className="col-sm-4">
                      <Autocomplete
                        inputProps={{
                          className: "form-control",
                          maxLength: "40",
                          id: "replaceTag",
                          required: true,
                        }}
                        items={this.state.completetaglist}
                        getItemValue={(item) => item.tag}
                        shouldItemRender={(item, value) => {
                          return item.tag
                            .toLowerCase()
                            .includes(value.toLowerCase());
                        }}
                        renderItem={(item, highlighted) => (
                          <div
                            key={item.tag}
                            className={
                              highlighted
                                ? "dropdown-item active"
                                : "dropdown-item"
                            }
                          >
                            {item.tag}
                          </div>
                        )}
                        renderMenu={(children) => (
                          <div
                            className="autocompleteMenu"
                            style={{ zIndex: 999 }}
                          >
                            {children}
                          </div>
                        )}
                        wrapperStyle={{}}
                        value={this.state.replaceTag}
                        onChange={(e) => {
                          this.setState({ replaceTag: e.target.value });
                        }}
                        onSelect={(value) =>
                          this.setState({ replaceTag: value })
                        }
                      />
                    </div>
                  </div>
                  {this.state.findTag &&
                    this.state.completetaglist
                      .map((x) => x.tag)
                      .includes(this.state.findTag) && (
                      <TagSearchTbl
                        date={
                          this.state.findDateRange
                            ? this.state.findDateRangeStart
                            : null
                        }
                        dateEnd={
                          this.state.findDateRange
                            ? this.state.findDateRangeEnd
                            : null
                        }
                        tag={this.state.findTag}
                        acct={this.state.acct}
                        auth={this.state.auth}
                      />
                    )}
                </div>
                <div className="modal-footer">
                  <button type="submit" className="btn btn-danger">
                    Replace
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default TagTbl;
